import { useState, useRef } from "react";
import Slider from "react-slick";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import SliderNavigation from "../SliderNavigation";
import { convertStringToArray } from "../../Utils/utils";

const Photos = () => {
  const navigate = useNavigate();
  const { getText } = useLanguageTranslation();
  const slider = useRef();
  const { languageType } = useSelector((state) => state.homeSlice);

  const {
    data: photosGalleryData = [],
    // photosGalleryError,
    isLoading: photosGalleryIsLoading,
  } = useGetProtectedApiDataQuery({ url: "photo_gallery", lang: languageType });

  const photoGalleryArray = photosGalleryData.map((item) => ({
    ...item,
    photoArray: convertStringToArray(item.field_mulitple_photo_upload),
  }));

  // console.log({ photoGalleryArray });

  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false,
    customPaging: (i) => (
      <button>
        <span className="dot" />
      </button>
    ),
    // dotsClass: "slick-dots custom-dots",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (photosGalleryIsLoading) {
    return (
      <div className="photo-loader sec-loader">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div className="tab-pane active" id="photos">
      <div>
        <Slider {...settings} ref={slider}>
          {photoGalleryArray?.map((item, index) => (
            <div className="home-gallery-item-wrap" key={index}>
              <div className="gallery-card">
                <div className="crd-title">
                  <p className="title-txt">{item.title}</p>
                </div>
                <div className="card-imgs">
                  {item.photoArray.slice(0, 2).map((item, i) => (
                    <img
                      key={i}
                      src={`${process.env.REACT_APP_IMAGE_URL}${item?.file_path}`}
                      alt=""
                    />
                  ))}
                </div>
                <div className="card-buttons">
                  <Link
                    // href=""
                    to={`/photo-gallery-detail/${item.nid}`}
                    className="quick-btn"
                  >
                    {getText("View More", "और देखो")}
                  </Link>
                </div>
              </div>
            </div>
            // <div
            //   className="card-sec"
            //   key={index}
            //   onClick={() => handlePhotoClick(item.nid)}
            //   style={{ cursor: "pointer" }}
            // >
            //   <div className="img-sec">
            //     <img
            //       src={`${process.env.REACT_APP_IMAGE_URL}/${item?.field_image_media}`}
            //       alt={item.title}
            //     />
            //   </div>
            //   <div className="desc-sec" style={{ cursor: "pointer" }}>
            //     <p>{item.title.slice(0, 70)}</p>
            //   </div>
            // </div>
          ))}
        </Slider>
      </div>
      <div className="flex-box">
        <div className="btn-sec">
          <SliderNavigation slider={slider} section={"photo gallery"} />
          <a
            href="#"
            className="quick-btn"
            onClick={(e) => {
              e.preventDefault();
              navigate("/photo-gallery-detail");
            }}
            aria-label={"View All Photos"}
          >
            {getText("View All", "सभी देखें")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Photos;
